import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Link } from '@mui/material';

export default function HorizontalFileCard({
    fileName= "NoFileName",
    fileIcon = process.env.PUBLIC_URL + '/assets/image/pdf_ico2.png',
    onTitleClick,
    children
}) {

  const onFileTitleClick = () => {
    if (onTitleClick) {
      onTitleClick();
    }
  }

  return (
    <Card sx={{ display: 'flex' , width: "98%" , m:1, 
                boxShadow: '3',
                '&:hover': { boxShadow: '18' , borderColor: '#c5bcbc'}  }}>
          <CardMedia
              component="img"
              height="120"
              sx={{ 
                  width: 120, 
                  p:1,
                  m:2
                }}
              image={fileIcon}
              alt="file"
          />
          <Box sx={{ display: 'flex', flexDirection: 'column'  }}>
              <CardContent sx={{ flex: '1 0 auto' }}>
                  <Link underline="hover" onClick={ () => onFileTitleClick() }>
                    <Typography component="div" variant="subtitle2"  >
                      {fileName}
                    </Typography>
                  </Link>
                    {children}
              </CardContent>
          </Box>
          {/* <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <CardContent sx={{ flex: '1 0 auto' }}>
                    {children}
              </CardContent>
          </Box> */}
 
    </Card>
  );
}